import { calibrationDeviceRailBranchVariants } from '@/features/calibration/config/calibrationDeviceRail';
import type { CalibrationDeviceTreeRow } from '@/features/calibration/types/calibrationDeviceTree';
import { Button } from '@/shared/components/ui/button';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { Trans } from '@lingui/react/macro';
import type { CSSProperties, Ref } from 'react';

export function CalibrationDeviceRailStateRow({
  row,
  onRetryDeviceBranch,
  measureRef,
  virtualIndex,
  style,
}: {
  row: Extract<CalibrationDeviceTreeRow, { kind: 'device-state' }>;
  onRetryDeviceBranch: (stationId: string) => void;
  measureRef: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <div className={calibrationDeviceRailBranchVariants({ edge: row.edge })}>
        {row.state === 'pending' ? (
          <Skeleton className="my-0.5 h-6 w-full" />
        ) : row.state === 'failed' ? (
          <Button variant="ghost" size="sm" onClick={() => onRetryDeviceBranch(row.stationId)}>
            <Trans>Retry devices</Trans>
          </Button>
        ) : (
          <p className="px-1.5 py-1 text-[11px] text-muted-foreground">
            <Trans>No devices</Trans>
          </p>
        )}
      </div>
    </li>
  );
}
